import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Games.css';

const products = [
  { name: 'Campus T-shirt', cost: 12, targetMargin: 0.5 },
  { name: 'Productivity Journal', cost: 7, targetMargin: 0.6 },
  { name: 'Reusable Bottle', cost: 9, targetMargin: 0.45 },
];

const PricingChallengeGame = () => {
  const [round, setRound] = useState(0);
  const [priceInput, setPriceInput] = useState('');
  const [score, setScore] = useState(0);
  const [message, setMessage] = useState('');
  const [done, setDone] = useState(false);

  const current = products[round];
  const targetPrice = useMemo(
    () => Number((current.cost * (1 + current.targetMargin)).toFixed(2)),
    [current]
  );

  const submitPrice = () => {
    const entered = Number(priceInput);
    if (!entered || entered <= 0) {
      setMessage('Enter a valid selling price first.');
      return;
    }

    const diff = Math.abs(entered - targetPrice);
    if (diff <= 0.5) {
      setScore((prev) => prev + 100);
      setMessage('Excellent pricing choice.');
    } else if (diff <= 1.5) {
      setScore((prev) => prev + 60);
      setMessage('Close. Slightly adjust for stronger margin and demand balance.');
    } else {
      setScore((prev) => prev + 25);
      setMessage('Too far from target. Revisit your margin strategy.');
    }
  };

  const nextRound = () => {
    if (round === products.length - 1) {
      setDone(true);
      return;
    }
    setRound((prev) => prev + 1);
    setPriceInput('');
    setMessage('');
  };

  const restart = () => {
    setRound(0);
    setPriceInput('');
    setScore(0);
    setMessage('');
    setDone(false);
  };

  return (
    <main className="game-shell">
      <header className="game-header">
        <h1>Pricing Challenge</h1>
        <p>Score: {score}</p>
      </header>

      {!done && (
        <section className="game-card">
          <h2>{current.name}</h2>
          <p>Unit cost: ${current.cost}</p>
          <p>Target margin: {Math.round(current.targetMargin * 100)}%</p>
          <p className="game-tip">Hint target price: ${targetPrice}</p>

          <label className="game-label" htmlFor="price">Your selling price</label>
          <input
            id="price"
            className="game-input"
            type="number"
            step="0.01"
            value={priceInput}
            onChange={(event) => setPriceInput(event.target.value)}
          />

          <div className="game-row">
            <button type="button" className="game-btn" onClick={submitPrice}>Submit Price</button>
            <button type="button" className="game-btn muted" onClick={nextRound}>Next</button>
          </div>

          {message && <p className="game-feedback">{message}</p>}
        </section>
      )}

      {done && (
        <section className="game-card">
          <h2>Pricing rounds complete.</h2>
          <p>Final score: {score} / 300</p>
          <div className="game-row">
            <button type="button" className="game-btn" onClick={restart}>Play Again</button>
            <Link to="/games" className="game-link">Back to Games</Link>
          </div>
        </section>
      )}
    </main>
  );
};

export default PricingChallengeGame;
